import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "record-list__heading" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "record-list__items" }


export default /*@__PURE__*/_defineComponent({
  __name: 'RecordList',
  props: {
    title: {},
    eyebrow: {},
    description: {},
    wide: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["surface-card record-list", { 'record-list--wide': __props.wide }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      (__props.eyebrow)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.eyebrow), 1))
        : _createCommentVNode("", true),
      _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
      (__props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})